import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { Box, Heading } from '@wix/design-system';
import { Article, ArticleType, Category } from '@wix/answers-api';
import { CategoryArticlesSection } from './CategoryArticlesSection';
import { DATA_HOOKS } from '../../dataHooks';
import css from './index.module.scss';

type CategoryArticlesProps = {
  category: Category;
  subCategory?: Category;
  categoryArticles?: Article[];
};

export const CategoryArticles: FunctionComponent<CategoryArticlesProps> = ({
  category,
  subCategory,
  categoryArticles,
}) => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [knownIssues, setKnownIssues] = useState<Article[]>([]);
  const [featureRequests, setFeatureRequests] = useState<Article[]>([]);

  const mapArticles = useCallback((newArticles: Article[]) => {
    setArticles(
      newArticles.filter((article) => article.type === ArticleType.ARTICLE)
    );
    setKnownIssues(
      newArticles.filter((article) => article.type === ArticleType.KNOWN_ISSUE)
    );
    setFeatureRequests(
      newArticles.filter(
        (article) => article.type === ArticleType.FEATURE_REQUEST
      )
    );
  }, []);

  useEffect(() => {
    if (categoryArticles) {
      mapArticles(categoryArticles);
    }
  }, [categoryArticles, mapArticles]);

  return (
    <Box direction="vertical" className={css.wrapper}>
      <Heading
        size="small"
        className={css.title}
        as="h1"
        dataHook={DATA_HOOKS.CATEGORY_ARTICLES_TITLE}
      >
        {subCategory ? subCategory.name : category.name}
      </Heading>
      <CategoryArticlesSection
        selectedCategoryId={subCategory?.id || category.id}
        articles={articles}
        type={ArticleType.ARTICLE}
        startIndex={0}
      />
      <CategoryArticlesSection
        selectedCategoryId={subCategory?.id || category.id}
        articles={knownIssues}
        type={ArticleType.KNOWN_ISSUE}
        startIndex={articles.length}
      />
      <CategoryArticlesSection
        selectedCategoryId={subCategory?.id || category.id}
        articles={featureRequests}
        type={ArticleType.FEATURE_REQUEST}
        startIndex={knownIssues.length + articles.length}
      />
    </Box>
  );
};
